import { Tooltip as AntTooltip } from "antd";
import React from "react";

import { Either } from "@morphism/fp";
import { NewBranch as GenericBranch } from "~/Branch";
import { Company } from "~/Company";
import * as Driver from "~/Driver";
import { Block } from "~/Layout";

export namespace Branch {

  export function BranchTooltip({
    driver,
  }: {
    readonly driver: Either.ErrorOr<Driver.Driver>;
  }) {
    const dvirDriver = pipe(
      driver,
      Either.map((driver) => driver),
      Either.getOrElseW(() => ({ id: undefined, name: undefined }))
    );
    const { drivers } = Driver.Drivers.use();
    const matchingDriver = drivers.find((d) => d.id === dvirDriver?.id);

    let title = "Driver's branch:";
    let branchLocationName = GenericBranch.name(undefined);
    if (matchingDriver) {
      if (matchingDriver.branch?.name) {
        branchLocationName = GenericBranch.name(matchingDriver.branch);
      } else if (matchingDriver.homeOffice) {
        title = "Driver's work reporting location:";
        branchLocationName = Company.Location.toString(
          matchingDriver?.homeOffice
        );
      }
    }

    return (
      <AntTooltip
        title={GenericBranch.TooltipTitle(title, branchLocationName)}
        mouseEnterDelay={0.5}
      >
        <Block.Component left right>
          <Driver.Name.Component noLink {...dvirDriver} />
        </Block.Component>
      </AntTooltip>
    );
  }
}
